/**
 * RouteTracker Component
 * Automatically tracks page views in Google Analytics when routes change
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../utils/analytics';

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    analytics.pageView(location.pathname + location.search);

    // Also send to gtag directly for proper GA4 tracking
    if (window.gtag) {
      window.gtag('config', 'G-3TKEPZQBCE', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
}
